module.exports = __webpack_public_path__ + "static/media/bed_new_pack_cat_FR_768x290.2fc75680.png";